import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DivisionContextService } from '@app/core/services/division/division-context.service';
import { Division } from '@app/features/division/models/division.interface';
import { DivisionService } from '@app/features/division/services/division.service';
import { FieldOption } from '@app/shared/models/field.interface';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'vfs-division-selection-filter',
  templateUrl: './division-selection-filter.component.html',
  styleUrls: ['./division-selection-filter.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => DivisionSelectionFilterComponent)
    }
  ]
})
export class DivisionSelectionFilterComponent implements OnInit, ControlValueAccessor {
  @Input() formControlName: string;

  divisions$: Observable<Division[]>;
  selected$: Observable<string[]>;
  options$: Observable<FieldOption[]>;

  // ControlValueAccessor
  disabled: boolean;
  value: any;

  constructor(protected divisionService: DivisionService, protected divisionContextService: DivisionContextService) {}

  ngOnInit() {
    this.divisions$ = this.divisionService.getOfLoggedUser();
    this.selected$ = this.divisionContextService.getDivisionFilter().pipe(map(context => context.divisions));
    this.options$ = combineLatest([this.divisions$, this.selected$]).pipe(
      map(result => ({ all: result[0], selected: result[1] })),
      map(div => (div.selected.length > 0 ? div.all.filter(dv => div.selected.includes(dv.id)) : div.all)),
      map(divisions =>
        this.sortDivisions(divisions).map(division => ({ label: division.description, value: division.id }))
      )
    );
  }

  sortDivisions(divisions: Division[]): Division[] {
    return divisions.sort((a, b) => a.description.localeCompare(b.description));
  }

  // ControlValueAccessor functions
  onChange = (rating: number) => {};
  onTouched = () => {};

  writeValue(obj: any): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
